import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";
import { CommonErrorCodeEnum } from "jadro-pico/enums/common/CommonErrorCodeEnum.ts";
import { FieldErrorCodeEnum } from "jadro-pico/enums/common/FieldErrorCodeEnum.ts";
import { defineErrorResources } from "./defineErrorResources.ts";

export const CommonErrorResources = defineErrorResources({
  [LanguageEnum.CS]: {
    [CommonErrorCodeEnum.VALIDATION_FAILED]: "Validace selhala",
    [CommonErrorCodeEnum.BAD_REQUEST]: "Neplatný požadavek",
    [CommonErrorCodeEnum.MISSING_REQUIRED_PARAMS]: "Chybí povinné parametry",
    [CommonErrorCodeEnum.UNAUTHORIZED]: "Nepřihlášen",
    [CommonErrorCodeEnum.FORBIDDEN]: "Nemáte oprávnění",
    [CommonErrorCodeEnum.NOT_FOUND]: "Nenalezeno",
    [CommonErrorCodeEnum.CONFLICT]: "Konflikt dat",
    [CommonErrorCodeEnum.PAYLOAD_TOO_LARGE]: "Požadavek je příliš velký",
    [CommonErrorCodeEnum.UNSUPPORTED_MEDIA_TYPE]: "Nepodporovaný formát dat",
    [CommonErrorCodeEnum.TOO_MANY_REQUESTS]: "Příliš mnoho požadavků",
    [CommonErrorCodeEnum.INTERNAL_SERVER_ERROR]: "Vnitřní chyba serveru",
    [CommonErrorCodeEnum.SERVICE_UNAVAILABLE]: "Služba není dostupná",
    [FieldErrorCodeEnum.REQUIRED]: "Povinné pole",
    [FieldErrorCodeEnum.INVALID_TYPE]: "Neplatný typ hodnoty",
    [FieldErrorCodeEnum.TOO_SHORT]: "Příliš krátké",
    [FieldErrorCodeEnum.TOO_LONG]: "Příliš dlouhé",
    [FieldErrorCodeEnum.INVALID_FORMAT]: "Neplatný formát",
    [FieldErrorCodeEnum.INVALID]: "Neplatná hodnota",
  },
  [LanguageEnum.EN]: {
    [CommonErrorCodeEnum.VALIDATION_FAILED]: "Validation failed",
    [CommonErrorCodeEnum.BAD_REQUEST]: "Bad request",
    [CommonErrorCodeEnum.MISSING_REQUIRED_PARAMS]: "Missing required parameters",
    [CommonErrorCodeEnum.UNAUTHORIZED]: "Not authenticated",
    [CommonErrorCodeEnum.FORBIDDEN]: "Insufficient permissions",
    [CommonErrorCodeEnum.NOT_FOUND]: "Not found",
    [CommonErrorCodeEnum.CONFLICT]: "Data conflict",
    [CommonErrorCodeEnum.PAYLOAD_TOO_LARGE]: "Request too large",
    [CommonErrorCodeEnum.UNSUPPORTED_MEDIA_TYPE]: "Unsupported media type",
    [CommonErrorCodeEnum.TOO_MANY_REQUESTS]: "Too many requests",
    [CommonErrorCodeEnum.INTERNAL_SERVER_ERROR]: "Internal server error",
    [CommonErrorCodeEnum.SERVICE_UNAVAILABLE]: "Service unavailable",
    [FieldErrorCodeEnum.REQUIRED]: "Required field",
    [FieldErrorCodeEnum.INVALID_TYPE]: "Invalid value type",
    [FieldErrorCodeEnum.TOO_SHORT]: "Too short",
    [FieldErrorCodeEnum.TOO_LONG]: "Too long",
    [FieldErrorCodeEnum.INVALID_FORMAT]: "Invalid format",
    [FieldErrorCodeEnum.INVALID]: "Invalid value",
  },
});
